/**
 * API Service para gestión de Badges (Administrador)
 * FunRead - Admin Badges Management
 *
 * KHAN-229: [API Standardization] endpoints migrados de Badges/admin/*
 * (verbos en el path + segmento admin/ duplicado) a un unico recurso
 * `badges` + metodo HTTP; la diferenciacion admin/no-admin ahora es por
 * permission classes en el backend (IsAdmin), no por path. Ver
 * apps/badges/views.py::BadgeViewSet para el detalle de la migracion. El
 * shape de cada respuesta no cambia.
 */

import axios from 'axios';
import { BASE_URL } from '../../settings';

/**
 * Obtener todos los badges con estadísticas (Admin)
 * Antes: GET Badges/admin/ -- ahora GET badges/ (mismo shape admin porque
 * el caller es admin; ver BadgeViewSet.list()/_admin_list()).
 */
export const getAllBadgesAdmin = async (token, filters = {}) => {
  try {
    const params = new URLSearchParams();

    if (filters.search) {
      params.append('search', filters.search);
    }

    if (filters.type) {
      params.append('type', filters.type);
    }

    const response = await axios.get(
      `${BASE_URL}badges/?${params.toString()}`,
      {
        headers: {
          'Authorization': token
        }
      }
    );

    return response.data;
  } catch (error) {
    console.error('Error al obtener badges:', error);
    throw error;
  }
};

/**
 * Obtener detalle de un badge (Admin)
 * Antes: GET Badges/admin/detail/{id}/ -- ahora GET badges/{id}/.
 */
export const getBadgeDetail = async (badgeId, token) => {
  try {
    const response = await axios.get(
      `${BASE_URL}badges/${badgeId}/`,
      {
        headers: {
          'Authorization': token
        }
      }
    );

    return response.data;
  } catch (error) {
    console.error('Error al obtener detalle del badge:', error);
    throw error;
  }
};

/**
 * Crear un nuevo badge (Admin)
 * Antes: POST Badges/admin/create/ -- ahora POST badges/.
 */
export const createBadgeAdmin = async (badgeData, token) => {
  try {
    const response = await axios.post(
      `${BASE_URL}badges/`,
      badgeData,
      {
        headers: {
          'Authorization': token,
          'Content-Type': 'application/json'
        }
      }
    );

    return response.data;
  } catch (error) {
    console.error('Error al crear badge:', error);
    throw error;
  }
};

/**
 * Actualizar un badge existente (Admin)
 * Antes: PUT Badges/admin/update/{id}/ -- ahora PATCH badges/{id}/ (el
 * backend ya no expone PUT en este recurso, ver BadgeViewSet -- solo
 * partial_update()).
 */
export const updateBadgeAdmin = async (badgeId, badgeData, token) => {
  try {
    const response = await axios.patch(
      `${BASE_URL}badges/${badgeId}/`,
      badgeData,
      {
        headers: {
          'Authorization': token,
          'Content-Type': 'application/json'
        }
      }
    );

    return response.data;
  } catch (error) {
    console.error('Error al actualizar badge:', error);
    throw error;
  }
};

/**
 * Eliminar un badge (Admin)
 * Antes: DELETE Badges/admin/delete/{id}/ -- ahora DELETE badges/{id}/.
 */
export const deleteBadgeAdmin = async (badgeId, token) => {
  try {
    const response = await axios.delete(
      `${BASE_URL}badges/${badgeId}/`,
      {
        headers: {
          'Authorization': token
        }
      }
    );

    return response.data;
  } catch (error) {
    console.error('Error al eliminar badge:', error);
    throw error;
  }
};

/**
 * Asignar badges a todos los usuarios (Admin - Masivo)
 * Antes: POST Badges/admin/assign-all/ -- ahora POST badges/assignments/recompute/.
 */
export const assignBadgesToAll = async (token) => {
  try {
    const response = await axios.post(
      `${BASE_URL}badges/assignments/recompute/`,
      {},
      {
        headers: {
          'Authorization': token
        }
      }
    );

    return response.data;
  } catch (error) {
    console.error('Error en asignación masiva de badges:', error);
    throw error;
  }
};

/**
 * Subir icono de badge
 */
export const uploadBadgeIcon = async (file, token) => {
  try {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('galleryType', '1'); // CustomIMG según el proyecto
    
    const response = await axios.post(
      `${BASE_URL}media/`,
      formData,
      {
        headers: {
          'Authorization': token,
          'Content-Type': 'multipart/form-data'
        }
      }
    );
    
    return response.data;
  } catch (error) {
    console.error('Error al subir icono:', error);
    throw error;
  }
};
